'use strict';
import request from '@/utils/request';
class NotificationsService{
    static list(data){
        return request({
            url:'/notifications/getnotifications',
            method:'post',
            data
        })
    }
    
}

export default NotificationsService
